module.exports = __webpack_public_path__ + "img/config.bca471c2.svg";